<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-08-13 15:02 -->
<!-- Description: Muestra de formularios con Bootstrap 4.6 -->
<template>
  <div class="sample-forms">
    <div class="container-fluid py-4">
      <h1 class="mb-4">Muestra de Formularios</h1>

      <!-- Formulario vertical básico -->
      <div class="card mb-4">
        <div class="card-header">1. Formulario vertical</div>
        <div class="card-body">
          <form>
            <div class="form-group">
              <label for="v-email">Correo electrónico</label>
              <input
                id="v-email"
                type="email"
                class="form-control"
                placeholder="nombre@ejemplo.com"
              />
            </div>
            <div class="form-group">
              <label for="v-password">Contraseña</label>
              <input
                id="v-password"
                type="password"
                class="form-control"
                placeholder="Contraseña"
              />
            </div>
            <div class="form-group form-check">
              <input
                id="v-check"
                type="checkbox"
                class="form-check-input"
              />
              <label class="form-check-label" for="v-check">
                Recordarme
              </label>
            </div>
            <button type="submit" class="btn btn-primary">Ingresar</button>
          </form>
        </div>
      </div>

      <!-- Formulario lineal (horizontal) -->
      <div class="card mb-4">
        <div class="card-header">2. Formulario lineal (horizontal)</div>
        <div class="card-body">
          <form>
            <div class="form-group row">
              <label for="h-email" class="col-sm-2 col-form-label">
                Correo
              </label>
              <div class="col-sm-10">
                <input
                  id="h-email"
                  type="email"
                  class="form-control"
                  placeholder="nombre@ejemplo.com"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="h-password" class="col-sm-2 col-form-label">
                Contraseña
              </label>
              <div class="col-sm-10">
                <input
                  id="h-password"
                  type="password"
                  class="form-control"
                  placeholder="Contraseña"
                />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-sm-10 offset-sm-2">
                <div class="form-check">
                  <input
                    id="h-check"
                    type="checkbox"
                    class="form-check-input"
                  />
                  <label class="form-check-label" for="h-check">
                    Recuérdame
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-sm-10 offset-sm-2">
                <button type="submit" class="btn btn-primary">
                  Ingresar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- Formulario inline -->
      <div class="card mb-4">
        <div class="card-header">3. Formulario inline</div>
        <div class="card-body">
          <form class="form-inline">
            <label class="sr-only" for="i-name">Nombre</label>
            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
              <div class="input-group-prepend">
                <div class="input-group-text">@</div>
              </div>
              <input
                id="i-name"
                type="text"
                class="form-control"
                placeholder="Usuario"
              />
            </div>
            <label class="sr-only" for="i-password">Contraseña</label>
            <input
              id="i-password"
              type="password"
              class="form-control mb-2 mr-sm-2 mb-sm-0"
              placeholder="Contraseña"
            />
            <div class="form-check mb-2 mr-sm-2 mb-sm-0">
              <input
                id="i-check"
                type="checkbox"
                class="form-check-input"
              />
              <label class="form-check-label" for="i-check">
                Recordarme
              </label>
            </div>
            <button type="submit" class="btn btn-primary mb-2">
              Ingresar
            </button>
          </form>
        </div>
      </div>

      <!-- Formulario con tamaños de input -->
      <div class="card mb-4">
        <div class="card-header">4. Tamaños de inputs</div>
        <div class="card-body">
          <form>
            <div class="form-group">
              <label for="s-lg">Input grande (form-control-lg)</label>
              <input
                id="s-lg"
                type="text"
                class="form-control form-control-lg"
                placeholder=".form-control-lg"
              />
            </div>
            <div class="form-group">
              <label for="s-md">Input mediano (form-control)</label>
              <input
                id="s-md"
                type="text"
                class="form-control"
                placeholder=".form-control"
              />
            </div>
            <div class="form-group">
              <label for="s-sm">Input pequeño (form-control-sm)</label>
              <input
                id="s-sm"
                type="text"
                class="form-control form-control-sm"
                placeholder=".form-control-sm"
              />
            </div>
            <div class="form-group">
              <label for="s-range">Rango</label>
              <input
                id="s-range"
                type="range"
                class="form-control-range"
                min="0"
                max="100"
                value="50"
              />
            </div>
          </form>
        </div>
      </div>

      <!-- Formulario con distintos tipos de input -->
      <div class="card mb-4">
        <div class="card-header">5. Tipos de inputs</div>
        <div class="card-body">
          <form>
            <div class="form-row">
              <div class="col-md-6 mb-3">
                <label for="t-text">Texto</label>
                <input id="t-text" type="text" class="form-control" />
              </div>
              <div class="col-md-6 mb-3">
                <label for="t-number">Número</label>
                <input
                  id="t-number"
                  type="number"
                  class="form-control"
                  min="0"
                  step="1"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label for="t-date">Fecha</label>
                <input id="t-date" type="date" class="form-control" />
              </div>
              <div class="col-md-6 mb-3">
                <label for="t-time">Hora</label>
                <input id="t-time" type="time" class="form-control" />
              </div>
              <div class="col-md-6 mb-3">
                <label for="t-color">Color</label>
                <input
                  id="t-color"
                  type="color"
                  class="form-control"
                  value="#1a7bb9"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label for="t-url">URL</label>
                <input id="t-url" type="url" class="form-control" />
              </div>
              <div class="col-md-6 mb-3">
                <label for="t-tel">Teléfono</label>
                <input id="t-tel" type="tel" class="form-control" />
              </div>
              <div class="col-md-6 mb-3">
                <label for="t-search">Búsqueda</label>
                <input id="t-search" type="search" class="form-control" />
              </div>
              <div class="col-md-12 mb-3">
                <label for="t-select">Select</label>
                <select id="t-select" class="custom-select">
                  <option selected>Elegir...</option>
                  <option>Opción 1</option>
                  <option>Opción 2</option>
                  <option>Opción 3</option>
                </select>
              </div>
              <div class="col-md-12 mb-3">
                <label for="t-textarea">Textarea</label>
                <textarea
                  id="t-textarea"
                  class="form-control"
                  rows="3"
                  placeholder="Escribe aquí..."
                ></textarea>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- Formulario con validación -->
      <div class="card mb-4">
        <div class="card-header">6. Formulario con validación</div>
        <div class="card-body">
          <form class="needs-validation" novalidate>
            <div class="form-group">
              <label for="val-name">Nombre</label>
              <input
                id="val-name"
                type="text"
                class="form-control"
                required
              />
              <div class="invalid-feedback">
                Por favor, ingrese su nombre.
              </div>
            </div>
            <div class="form-group">
              <label for="val-city">Ciudad</label>
              <select id="val-city" class="custom-select" required>
                <option value="">Elegir...</option>
                <option>Lima</option>
                <option>Arequipa</option>
                <option>Cusco</option>
              </select>
              <div class="invalid-feedback">
                Por favor, seleccione una ciudad.
              </div>
            </div>
            <div class="form-group">
              <label for="val-notes">Notas</label>
              <textarea
                id="val-notes"
                class="form-control"
                rows="2"
              ></textarea>
            </div>
            <div class="form-group">
              <div class="form-check">
                <input
                  id="val-terms"
                  type="checkbox"
                  class="form-check-input"
                  required
                />
                <label class="form-check-label" for="val-terms">
                  Acepto los términos y condiciones
                </label>
                <div class="invalid-feedback">
                  Debe aceptar antes de continuar.
                </div>
              </div>
            </div>
            <button type="submit" class="btn btn-success">Enviar</button>
          </form>
        </div>
      </div>

      <!-- Formulario con text-help y estados -->
      <div class="card mb-4">
        <div class="card-header">
          7. Estados y texto de ayuda
        </div>
        <div class="card-body">
          <form>
            <div class="form-group">
              <label for="st-valid">Válido</label>
              <input
                id="st-valid"
                type="text"
                class="form-control is-valid"
                value="Contenido válido"
              />
            </div>
            <div class="form-group">
              <label for="st-invalid">Inválido</label>
              <input
                id="st-invalid"
                type="text"
                class="form-control is-invalid"
                value="Contenido inválido"
              />
              <div class="invalid-feedback">
                Este campo tiene un error.
              </div>
            </div>
            <div class="form-group">
              <label for="st-disabled">Deshabilitado</label>
              <input
                id="st-disabled"
                type="text"
                class="form-control"
                value="No editable"
                disabled
              />
            </div>
            <div class="form-group">
              <label for="st-readonly">Solo lectura</label>
              <input
                id="st-readonly"
                type="text"
                class="form-control"
                value="Solo lectura"
                readonly
              />
            </div>
            <div class="form-group">
              <label for="st-help">Campo con ayuda</label>
              <input
                id="st-help"
                type="password"
                class="form-control"
                aria-describedby="helpBlock"
              />
              <small id="helpBlock" class="form-text text-muted">
                Su contraseña debe tener al menos 8 caracteres.
              </small>
            </div>
          </form>
        </div>
      </div>

      <!-- Formulario con input-group -->
      <div class="card mb-4">
        <div class="card-header">8. Input groups</div>
        <div class="card-body">
          <form>
            <div class="form-group">
              <label for="ig-amount">Monto</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">S/</span>
                </div>
                <input
                  id="ig-amount"
                  type="number"
                  class="form-control"
                  step="0.01"
                />
                <div class="input-group-append">
                  <span class="input-group-text">.00</span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="ig-username">Usuario</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">@</span>
                </div>
                <input
                  id="ig-username"
                  type="text"
                  class="form-control"
                  placeholder="usuario"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="ig-file">Archivo</label>
              <div class="input-group">
                <div class="custom-file">
                  <input
                    id="ig-file"
                    type="file"
                    class="custom-file-input"
                  />
                  <label
                    class="custom-file-label"
                    for="ig-file"
                  >
                    Elegir archivo...
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- Formulario con checkboxes y radios -->
      <div class="card mb-4">
        <div class="card-header">9. Checkboxes y radios</div>
        <div class="card-body">
          <form>
            <fieldset class="form-group">
              <legend class="col-form-label">
                Intereses (checkboxes)
              </legend>
              <div class="form-check">
                <input
                  id="cb1"
                  type="checkbox"
                  class="form-check-input"
                  checked
                />
                <label class="form-check-label" for="cb1">
                  Deportes
                </label>
              </div>
              <div class="form-check">
                <input id="cb2" type="checkbox" class="form-check-input" />
                <label class="form-check-label" for="cb2">
                  Música
                </label>
              </div>
              <div class="form-check disabled">
                <input
                  id="cb3"
                  type="checkbox"
                  class="form-check-input"
                  disabled
                />
                <label class="form-check-label" for="cb3">
                  Lectura (deshabilitado)
                </label>
              </div>
            </fieldset>

            <fieldset class="form-group">
              <legend class="col-form-label">
                Género (radios)
              </legend>
              <div class="form-check">
                <input
                  id="rd1"
                  type="radio"
                  name="gender"
                  class="form-check-input"
                  checked
                />
                <label class="form-check-label" for="rd1">
                  Masculino
                </label>
              </div>
              <div class="form-check">
                <input
                  id="rd2"
                  type="radio"
                  name="gender"
                  class="form-check-input"
                />
                <label class="form-check-label" for="rd2">
                  Femenino
                </label>
              </div>
              <div class="form-check disabled">
                <input
                  id="rd3"
                  type="radio"
                  name="gender"
                  class="form-check-input"
                  disabled
                />
                <label class="form-check-label" for="rd3">
                  Otro (deshabilitado)
                </label>
              </div>
            </fieldset>

            <!-- Radios inline -->
            <fieldset class="form-group">
              <legend class="col-form-label">
                Prioridad (radios inline)
              </legend>
              <div class="form-check form-check-inline">
                <input
                  id="pr1"
                  type="radio"
                  name="priority"
                  class="form-check-input"
                  checked
                />
                <label class="form-check-label" for="pr1">Baja</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  id="pr2"
                  type="radio"
                  name="priority"
                  class="form-check-input"
                />
                <label class="form-check-label" for="pr2">Media</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  id="pr3"
                  type="radio"
                  name="priority"
                  class="form-check-input"
                />
                <label class="form-check-label" for="pr3">Alta</label>
              </div>
            </fieldset>
          </form>
        </div>
      </div>

      <!-- Formulario con selects múltiples -->
      <div class="card mb-4">
        <div class="card-header">10. Selects</div>
        <div class="card-body">
          <form>
            <div class="form-group">
              <label for="sel-multi">Múltiple</label>
              <select id="sel-multi" class="custom-select" multiple size="3">
                <option>Lima</option>
                <option>Arequipa</option>
                <option>Cusco</option>
                <option>Trujillo</option>
                <option>Iquitos</option>
              </select>
            </div>
            <div class="form-group">
              <label for="sel-grp">Con grupos</label>
              <select id="sel-grp" class="custom-select">
                <optgroup label="Costa">
                  <option>Lima</option>
                  <option>Trujillo</option>
                </optgroup>
                <optgroup label="Sierra">
                  <option>Cusco</option>
                  <option>Huancayo</option>
                </optgroup>
                <optgroup label="Selva">
                  <option>Iquitos</option>
                </optgroup>
              </select>
            </div>
            <div class="form-group">
              <label for="sel-sm">Pequeño</label>
              <select
                id="sel-sm"
                class="custom-select custom-select-sm"
              >
                <option selected>Pequeño</option>
                <option>Opción 1</option>
              </select>
            </div>
            <div class="form-group">
              <label for="sel-lg">Grande</label>
              <select
                id="sel-lg"
                class="custom-select custom-select-lg"
              >
                <option selected>Grande</option>
                <option>Opción 1</option>
              </select>
            </div>
          </form>
        </div>
      </div>

      </div>
  </div>
</template>
<script>
// script content
export default {
  name: "Sample",
  components: {
    //
  },

  // directives

  props: {
    //
  },

  data: () => ({
    //
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    //
    //
    //
  }
};
</script>
<style scoped></style>